import { Link, useLocation } from 'react-router-dom'

function AccessDenied() {
  const location = useLocation()

  return (
    <section className='access-denied' role='alert'>
      <span className='app-content__eyebrow'>Access control</span>
      <h1>Permission required</h1>
      <p>
        Your role does not allow access to {location.state?.from || 'this page'}
        .
      </p>
      <Link to='/dashboard'>Return to dashboard</Link>
    </section>
  )
}

export default AccessDenied
